// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.gc-auth-form-container .reset-btn {
  width: 530px;
  height: 60px;
  background: #6ACE6A;
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  letter-spacing: -0.25px;
  color: #FFFFFF;
  margin-top: 30px;
  cursor: pointer;
  border: none;
}
.gc-auth-form-container .reset-btn:hover {
  background: #7AEC7A;
}
.gc-auth-form-container .reset-btn:focus {
  background: #5CB85C;
}
.gc-auth-form-container .columnContainer {
  display: flex;
  flex-direction: column;
  color: red;
}

.password-error-text p {
  color: red;
  font-size: 12px;
  padding-left: 10px;
  line-height: 0;
  margin-bottom: 0;
}

.password-req {
  font-size: 12px;
  margin-top: 8px;
  display: inline-block;
  line-height: 28px;
}
@media (max-width: 1640px) {
  .password-req {
    line-height: 16px;
  }
}

.p-l-7 {
  padding-left: 7px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
